import { useQuery } from 'react-query';
import { useMemo } from 'react';
import FloorPlanCAUDesignationService from '../../../services/floorPlanCAUDesignationService';

/**
 * Hook to fetch CAU designation options from API
 * Follows the same pattern as useUnitTypesQuery
 *
 * @returns {Object} Object containing cauDesignations array, isLoading, and error
 */
export const useCAUDesignationsQuery = () => {
  const service = useMemo(() => new FloorPlanCAUDesignationService(), []);
  const queryKey = ['useCAUDesignationsQuery'];

  const { data, isLoading, error } = useQuery(
    queryKey,
    async () => {
      return await service.getCAUDesignations();
    },
    {
      staleTime: 1000 * 60 * 60, // Cache for 1 hour (designations rarely change)
      cacheTime: 1000 * 60 * 60 * 24, // Keep in cache for 24 hours
    },
  );

  return {
    cauDesignations: data || [],
    isLoading,
    error,
  };
};
